import { useTranslation } from 'next-i18next';
import { InviteWrapper, StyledInviteBtn } from './styles';
import ShareIcon from '@mui/icons-material/Share';
import InviteModal from './InviteModal';
import { useState } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { userInfoState } from '@/state/userInfo';
import { GLOBAL_MODALS, globalModals } from '@/state/globalSettings';
import ReferralBonus from '@/components/features/casino/rush/InviteBtn/ReferralBonus';

export default function InviteBox() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { userMetaData } = useAtomValue(userInfoState);
  const [modals, setModals] = useAtom(globalModals);

  const handleReferral = () => {
    if (!userMetaData?.name) {
      setModals({
        [GLOBAL_MODALS.LOGIN]: true,
      });
      return;
    }

    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <InviteWrapper>
        <StyledInviteBtn
          variant={'plain'}
          onClick={() => {
            handleReferral();
          }}
        >
          <ShareIcon sx={{ mr: 1 }} />
          <span>{t('Rush Referral')}</span>
        </StyledInviteBtn>
        <ReferralBonus />
      </InviteWrapper>
      <InviteModal isOpen={isOpen} onClose={handleClose} />
    </>
  );
}
